import { PERMISSOES_SERVICO } from "../auth";

export function emptyProfile() {
  return {
    id: null,
    matricula: "",
    nomeExibicao: "",
    ativo: true,
    permiteCriarServico: false,
    permissoesNovosServicos: [...PERMISSOES_SERVICO],
    versao: null,
    chamado: "",
    justificativa: ""
  };
}

export function toProfileForm(profile) {
  return {
    ...emptyProfile(),
    id: profile.id,
    matricula: profile.matricula || "",
    nomeExibicao: profile.nomeExibicao || "",
    ativo: profile.ativo !== false,
    permiteCriarServico: profile.permiteCriarServico === true,
    permissoesNovosServicos: profile.permissoesNovosServicos || [],
    versao: profile.versao,
    chamado: profile.chamado || "",
    justificativa: profile.justificativa || ""
  };
}

export function emptyLink() {
  return {
    servicoId: "",
    permissoes: [...PERMISSOES_SERVICO],
    ativo: true,
    expiraEm: "",
    versao: null,
    chamado: "",
    justificativa: ""
  };
}

export function toLinkForm(link) {
  return {
    ...emptyLink(),
    servicoId: String(link.servicoId),
    permissoes: link.permissoes || [],
    ativo: link.ativo !== false,
    expiraEm: link.expiraEm ? String(link.expiraEm).slice(0, 16) : "",
    versao: link.versao,
    chamado: link.chamado || "",
    justificativa: link.justificativa || ""
  };
}
